var add_cal_event = ( function( $ ) {

	var $containers;

	var _init = function() {
		$containers = $( 'div.add-cal-event' );

		$containers.each( _setup_cal_links );
	};

	var _setup_cal_links = function() {
		var title       = $( this ).data( 'event-title' ),
			duration    = $( this ).data( 'event-duration' ),
			start       = $( this ).data( 'event-start' ),
			end         = $( this ).data( 'event-end' ),
			description = $( this ).data( 'event-description' ),
			location    = $( this ).data( 'event-location' ),
			id          = $( this ).data( 'event-id' );

		var calendar_link = createCalendar( {
			options: {
				class: 'event-cal-links'
			},
			data: {
				title: title,
				start: new Date( start ),
				duration: duration,
				address: location,
				description: description
			}
		} );

		$( this ).append( calendar_link );

		_setup_link_toggle( $( this ) );

		_update_for_ics( start, end, id );
	};

	var _setup_link_toggle = function( $parent ) {
		$parent.find( 'a.toggle-add-actions' ).on( 'click', function( e ) {
			e.preventDefault();

			var $cal_links = $parent.find( '.event-cal-links' );

			$cal_links.slideToggle();
			$cal_links.toggleClass( 'open' );
		} )
	};

	_update_for_ics = function( start, end, event_id ) {
		var $ics_containers = $containers.find( 'a[href^="data:text/calendar"]' );

		$ics_containers.attr( 'href', window.location.origin + '/?add-to-calendar=' + event_id + '&start=' + _encode_uri( start ) + '&end=' + _encode_uri( end ) );
	}

	// Sometimes the function doesn't seem to correctly encode the + and so a fatal error can occur, so this function
	// manually encodes the + symbol
	_encode_uri = function ( str ) {
		return encodeURIComponent( str ).replace( '+', '%2B' );
	}


	if ( $( 'div.add-cal-event' ).length > 0 ) {
		_init();
	}

	return {}

} )( jQuery );

module.exports = add_cal_event;